import type { IconProps } from '../types/IconProps.ts';
export const X: IconProps = {
    name: 'X',
    children: [
        `<path d="m6 6 12 12M18 6 6 18" />`,
    ]
};